<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-11">
                    <strong class="card-title mb-3">Mutual Funds - <b class="ml-2"> Recommended Variable</b></strong>
                </div>
                <div class="col-md-1">
                    <goback></goback>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row mb5">
                <div class="col-md-6">
                </div>
            </div>
            <div class="mb10"></div>
            <div v-if="variableData.length > 0" class="table-responsive scrollbar app" v-dragscroll="true">
                <table class="table table-bordered fonts11 app-inner">
                    <thead>
                        <tr>
                            <th>Fund Filters</th>
                            <th v-for="(item, index) in variableData" :key="index">{{ item.lbl }}</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(key, index) in Object.keys(variableData[0].data)" :key="index">
                            <td style="font-weight: bold;">{{ key }}</td>
                            <td v-for="(item, subIdx) in variableData" :key="subIdx">
                                <input type="number" v-model="item.data[key]" @input="convertFloat(item, key)"></input>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <button type="button" class="btn btn-sm btn-primary" @click="submitVariableData()">Submit</button>
                    <button type="button" class="btn btn-sm btn-primary ml-2" @click="submitVariableSummaryData()">
                        Recommended Summary Update</button>
                </div>
            </div>
            <!--------PAGINATION------------>
        </div>
    </div>
    <!-- </card> -->
</template>
<script>
/* import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import Datepicker from "vuejs-datepicker"; */

import http from "@/lib/http";
//import { commonMixins } from "../../assets/mixins/common.js";
//import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
    name: "mf-variable",
    //components: { VueTabs, VTab, Datepicker },
    //mixins: [commonMixins, rawMixins],
    created() {
        //this.getVariableList();

    },
    mounted() {
        this.getVariableList();
    },
    methods: {
        submitVariableData() {
            console.log('Submit=> ', this.variableData);
            this.postVariableList();
        },
        submitVariableSummaryData() {
            this.fromSummaryUpdate = true;
            this.postVariableList();
        },
        /* prev() {
            this.pageToLoad = this.current_page - 1;
            this.fillTable();
        },
        goToPage(page) {
            this.pageToLoad = page;
            this.fillTable();
        },
        next() {
            console.log(this.$route.query);
            this.pageToLoad = this.current_page + 1;
            this.prevDisabled = 0;
            this.fillTable();
        }, */
        variableSummaryUpdate() {

            let payload = {};
            let _this = this;
            this.fromSummaryUpdate = false;
            http.put(
                "mutual-funds/new-mf-recommended-summary/update",
                payload,
                (error, response) => {

                    console.log("=> PUT: ", response);
                    if (response.responseType === 'success') {
                        _this.$toastr.success(response.msg);
                    } else {
                        _this.$toastr.error('Oops, something went wrong!', '', {});
                    }
                }
            );
        },
        postVariableList() {

            let payload = { data: [{ _id: this.variableDataId, "data": this.variableData }] };

            console.log('payload', payload);

            //return;
            let _this = this;
            http.put(
                "frontend/mutual-funds/mf-recommended-veriable/update",
                payload,
                (error, response) => {
                    console.log("postVariableList POST: ", response, _this.fromSummaryUpdate);
                    if (response.status === 'success') {
                        if (_this.fromSummaryUpdate) {
                            _this.variableSummaryUpdate();
                        } else {
                            _this.$toastr.success("Record updated successfully.");
                        }
                    } else {
                        _this.$toastr.error('Oops, something went wrong!', '', {});
                    }
                }
            );
        },
        getVariableList() {
            let self = this;
            http.get("frontend/mutual-funds/mf-recommended-veriable", {}, function (error, response) {
                console.log("### RES: FIRST ", response);
                if (response.status == 'success') {
                    console.log("### RES: ", response.data[0], response.data[0]._id);
                    self.variableDataId = response.data[0]._id;
                    self.variableData = response.data[0].data;
                }
            });
        },
        convertFloat(item, key) {
            // Convert the value to a float if it's not null
            item.data[key] = parseFloat(item.data[key]) || 0;
        }
    },
    data() {
        return {
            variableData: [],
            fromSummaryUpdate: false,
            /* variableData: [
                {
                    "lbl": "Equity",
                    "data": {
                        "aum": 1000,
                        "alpha": 0,
                        "vintage": 5,
                        "expRatio": 2.5,
                        "busRating": 0.5,
                        "valRating": 0.4,
                        "qtrlyRating": 0.5,
                        "debtRating": null,
                        "rrPositive": 50,
                        "rrGreater": 50,
                        "rrNegative": 50,
                        "meanNavRR": 15
                    }
                },
                {
                    "lbl": "Solutions",
                    "data": {
                        "aum": 1000,
                        "alpha": 0,
                        "vintage": 5,
                        "expRatio": 2.5,
                        "busRating": 0.5,
                        "valRating": 0.4,
                        "qtrlyRating": 0.5,
                        "debtRating": null,
                        "rrPositive": 50,
                        "rrGreater": 50,
                        "rrNegative": 50,
                        "meanNavRR": 15
                    }
                },
                {
                    "lbl": "Debt",
                    "data": {
                        "aum": 1000,
                        "alpha": 0,
                        "vintage": 3,
                        "expRatio": 1,
                        "busRating": null,
                        "valRating": null,
                        "qtrlyRating": null,
                        "debtRating": 0.7,
                        "rrPositive": null,
                        "rrGreater": null,
                        "rrNegative": 95,
                        "meanNavRR": 5
                    }
                },
                {
                    "lbl": "Hybrid",
                    "data": {
                        "aum": 1000,
                        "alpha": 0,
                        "vintage": 3,
                        "expRatio": 1.5,
                        "busRating": 0.5,
                        "valRating": 0.3,
                        "qtrlyRating": 0.5,
                        "debtRating": 0.7,
                        "rrPositive": null,
                        "rrGreater": null,
                        "rrNegative": 95,
                        "meanNavRR": 5
                    }
                },
                {
                    "lbl": "ETFs",
                    "data": {
                        "aum": 1000,
                        "alpha": null,
                        "vintage": 3,
                        "expRatio": 0.3,
                        "busRating": null,
                        "valRating": null,
                        "qtrlyRating": null,
                        "debtRating": null,
                        "rrPositive": null,
                        "rrGreater": null,
                        "rrNegative": 50,
                        "meanNavRR": 5
                    }
                },
                {
                    "lbl": "Index",
                    "data": {
                        "aum": 1000,
                        "alpha": null,
                        "vintage": 3,
                        "expRatio": 0.3,
                        "busRating": null,
                        "valRating": null,
                        "qtrlyRating": null,
                        "debtRating": null,
                        "rrPositive": null,
                        "rrGreater": null,
                        "rrNegative": 50,
                        "meanNavRR": 5
                    }
                },
                {
                    "lbl": "FoF-Domestic",
                    "data": {
                        "aum": 1000,
                        "alpha": null,
                        "vintage": 3,
                        "expRatio": 0.5,
                        "busRating": null,
                        "valRating": null,
                        "qtrlyRating": null,
                        "debtRating": null,
                        "rrPositive": null,
                        "rrGreater": null,
                        "rrNegative": 50,
                        "meanNavRR": 5
                    }
                },
                {
                    "lbl": "FoF-Foreign",
                    "data": {
                        "aum": 1000,
                        "alpha": null,
                        "vintage": 3,
                        "expRatio": 2,
                        "busRating": null,
                        "valRating": null,
                        "qtrlyRating": null,
                        "debtRating": null,
                        "rrPositive": null,
                        "rrGreater": null,
                        "rrNegative": 50,
                        "meanNavRR": 5
                    }
                }
            ], */
            variableDataId: "0",
        }
    },
};
</script>
<style>
form .col-md-3 {
    width: 40%;
}

.table td {
    padding: 5px 10px 5px 10px;
}

.table tr th span.sort.active {
    color: #ced4da;
}

.right-panel.fHeight {
    overflow: auto !important;
}

th.scheme-column {
    padding: 22px 70px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/mutual-funds/variable/mf-variable.vue